import Vue                  from 'vue'
import Vuex                 from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import baseModule           from './modules/base'
import errorModule          from './modules/error'

Vue.use(Vuex);

export default new Vuex.Store({
  state    : {},
  mutations: {},
  actions  : {},
  getters  : {},
  modules  : {
    billings          : baseModule,
    notifications     : baseModule,
    payments          : baseModule,
    users             : baseModule,
    adminBillings     : baseModule,
    adminNotifications: baseModule,
    adminFaqs         : baseModule,
    contractForm      : baseModule,
    contractFormError : errorModule,
    paymentNewError   : errorModule,
  },
  plugins  : [createPersistedState()],
});
